// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { HotkeysKeyless } from './NamesEventHotkey ';
export class HotkeysItem {
    constructor(actionName, hotkey) {
        this._ActionName = '';
        this._Hotkey = HotkeysKeyless;
        this._TemporaryHotkey = '';
        this.ActionName = actionName;
        this.Hotkey = hotkey;
    }
    get ActionName() {
        return this._ActionName;
    }
    set ActionName(value) {
        this._ActionName = value;
    }
    get Hotkey() {
        return this._Hotkey;
    }
    set Hotkey(value) {
        this._Hotkey = value.replace(/\s*\+\s*/g, '+'); // NOSONAR[typescript:S5852]
    }
    get TemporaryHotkey() {
        return this._TemporaryHotkey;
    }
    set TemporaryHotkey(value) {
        this._TemporaryHotkey = value.replace(/\s*\+\s*/g, '+'); // NOSONAR[typescript:S5852]
    }
}
